import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { trackEvent, EventType } from '../utils/analytics';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleSignUpClick = () => {
    trackEvent(EventType.SIGN_UP, { source: 'header' });
  };

  const handleLoginClick = () => {
    trackEvent(EventType.LOGIN, { source: 'header' });
  };

  return (
    <div className="fixed top-0 left-0 right-0 flex justify-center z-50 px-4">
      <header className="w-full max-w-5xl mt-4 py-3 md:py-4 px-4 md:px-6 flex items-center justify-between bg-white/70 backdrop-blur-md rounded-full border border-gray-200/20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="/images/logo.svg" 
            alt="OurPhotos Logo" 
            className="w-24 h-8 md:w-32 md:h-10"
          />
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/features" className="text-gray-600 hover:text-black transition-colors">
            Features
          </Link>
          <Link to="/pricing" className="text-gray-600 hover:text-black transition-colors">
            Pricing
          </Link>
          <Link to="/login" className="text-gray-600 hover:text-black transition-colors" onClick={handleLoginClick}>
            Log in
          </Link>
          <Link to="/register" className="bg-[#FF4444] text-white px-4 py-2 rounded-full hover:bg-[#FF3333] transition-colors" onClick={handleSignUpClick}>
            Sign up
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden p-2 rounded-full hover:bg-gray-100"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? (
            <X className="w-5 h-5 text-gray-800" />
          ) : (
            <Menu className="w-5 h-5 text-gray-800" />
          )}
        </button>
      </header>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 top-20 bg-white/95 backdrop-blur-sm z-40 flex flex-col md:hidden p-5">
          <nav className="flex flex-col gap-4 items-center text-center pt-8">
            <Link to="/features" 
              className="w-full py-3 text-gray-800 hover:text-black hover:bg-gray-50 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Features
            </Link>
            <Link to="/pricing" 
              className="w-full py-3 text-gray-800 hover:text-black hover:bg-gray-50 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link to="/login" 
              className="w-full py-3 text-gray-800 hover:text-black hover:bg-gray-50 rounded-lg transition-colors"
              onClick={() => {
                setMobileMenuOpen(false);
                handleLoginClick();
              }}
            >
              Log in
            </Link>
            <Link to="/register" 
              className="w-full py-3 bg-[#FF4444] text-white rounded-lg hover:bg-[#FF3333] transition-colors mt-4"
              onClick={() => {
                setMobileMenuOpen(false);
                handleSignUpClick();
              }}
            >
              Sign up
            </Link>
          </nav>
        </div>
      )}
    </div>
  );
};

export default Header;